module.exports = __webpack_public_path__ + "media/960bn2.5341a935.mp4";